import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_USER_PLAID_STATUS_QUERY_KEY } from "../../../constants/queryKeys";

export const useUserPlaidStatus = (search) => {
  const searchParams = new URLSearchParams({ search }).toString();

  return useQuery({
    queryKey: [SUPPORT_USER_PLAID_STATUS_QUERY_KEY, search],
    queryFn: async () => {
      if (!search) { return null; }
      return makeApiRequest({
        endpoint: `/api/support/user-plaid-status?${searchParams}`,
        method: "GET"
      });
    },
    enabled: !!search,
    retry: false
  });
};
